module.exports = __webpack_public_path__ + "media/images/user/oita-matome-24265e90a5a7240f516745ecd50b483b.svg";